import ReactDOM from 'react-dom/client';
import { Spin } from 'antd';
// 当前正在请求的数量
let requestCount = 0;
// 显示loading
export const showLoading = () => {
  if (requestCount === 0) { // 解决一个页面多个接口请求需要loading
    const dom = document.createElement('div');
    dom.setAttribute('id', 'loading');
    document.body.appendChild(dom);
    const root = ReactDOM.createRoot(dom);
    root.render(<Spin size="large" />);
  }
  requestCount++;
};
// 隐藏loading
export const hideLoading = () => {
  requestCount--;
  if (requestCount === 0) {
    document.body.removeChild(document.getElementById('loading'));
  }
};